module.exports = __webpack_public_path__ + "img/carousel-2.a3b2abe8.jpg";